export default {
  metadata: {
    version: '1.0.0',
    id: 'Segmented-ring-item-1.0.0',
    name: 'JDSSegmentedRingItem'
  },
  hierarchy: {
    arc: []
  },
  base: {
    arc: {
      radius: 24,
      arcWidth: 2,
      fill: '{primary50}',
      start: 0,
      end: 360
    }
  },
  variant: {
    size: {
      'xtra-xtra-large': {
        arc: {
          radius: 68,
          arcWidth: 4
        }
      },
      'xtra-large': {
        arc: {
          radius: 34,
          arcWidth: 3
        }
      },
      large: {
        arc: {
          radius: 30,
          arcWidth: 3
        }
      },
      small: {
        arc: {
          radius: 20,
          arcWidth: 2
        }
      },
      'xtra-small': {
        arc: {
          radius: 16,
          arcWidth: 2
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      size: {
        values: [
          'medium',
          'xtra-xtra-large',
          'xtra-large',
          'large',
          'small',
          'xtra-small'
        ]
      }
    },
    data: {
      arc: {
        start: {
          type: 'number',
          name: 'startAngle'
        },
        end: {
          type: 'number',
          name: 'endAngle'
        }
      }
    }
  }
};
